// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,ScoreCard
}                         from '../../../components';
import {Link} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

class PartnerTournament extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerTournament');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;

  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerTournament');
  }

  render() {
    const {
      statsTable,
      scoreCard
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;

    return(
      <div>
        <div className="row">
          <ScoreCard name="score_card_tournament" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
        </div>
        <div className="row" style={{padding: '1%'}}>
          <RaisedButton
            onClick={this.handleClick}
            label="Add"
            style={{float:'right'}}
            secondary={true}
          />
          <Popover
            open={this.state.open}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}
            onRequestClose={this.handleRequestClose}
          >
            <Menu>
              <Link to="./crud/addTournament"><MenuItem primaryText="Events" /></Link>
              <Link to="./crud/addTeam"><MenuItem primaryText="New Team" /></Link> 

            </Menu>
          </Popover>
        </div>
        <div className="row">

        <div className="row">
            <StatsTable bigTable={true} name="tournament_summary" displayName="Event Details" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="row">
            <StatsTable name="lead_summary" game_type_id={13,14, 22} displayName="Lead summary" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>

           <div className="lead_flow">
          <div className="lead_header">
          <h4>Lead Flow</h4>
          </div>
         <div className="row hot_leads_pipeline">
         <div className="col-md-3">
          <StatsTable bigTable={true} name="response" game_type_id={13,14, 22} displayName="Response" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="contact_later" game_type_id={13,14,22} displayName="Contact Later" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="demo" game_type_id={13,14,22} displayName="Demos" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="col-md-3">
           <StatsTable bigTable={true} name="verbal_confirmation" game_type_id={13,14,22} displayName="Verbal Confirmation" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          </div>
         </div> 
         <div className="row">
            <StatsTable bigTable={true} name="all_cust_tourny"  displayName="All Customers" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
         <div className="row">
              <StatsTable bigTable={true} name="tournament_teams" displayName="All Teams" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>

          <div className="row">
            <StatsTable bigTable={true} name="all_leads" game_type_id={13,14,22} displayName="All Leads" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>

          
        </div>
      </div>
    );
  }
}

export default PartnerTournament;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerTournament/PartnerTournament.js